import React, { useEffect, useState } from "react";
import { Form, Input, Modal, theme } from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function ShippingPackingLIstModal (props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages , setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]);


  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();


  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();

      if (target?.id) {
        await PATCH(`${URL_SETTING.PACKING}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.PACKING, data);
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
 
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไข Packing" : "เพิ่ม Packing"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      
      <ErrorMessages message={errorMessages}/> 

      <Form
        form={form}
        layout="vertical"
        style={{ padding: "10px 20px" }}
      >
        <Form.Item
          label="ชื่อ Packing"
          name="name"
          rules={[{ required: true, message: "กรุณากรอก ชื่อ Packing" }]}
        >
          <Input placeholder="Packing"/>
        </Form.Item>
      </Form>
    </Modal>
  );
}